<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>函数库</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button v-if="state != 'archived'" type="primary" @click="doNew" class="c-m-l-10">
          新建函数
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:name|string#or': searchValue,
                'regex:tag|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'definedFunction',
                title: '函数库'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('DefinedFunction,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('DefinedFunction,able') && scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('DefinedFunction,able') && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('DefinedFunction,remove') && scope.row.state == 1"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields">
            <template slot="keywordSubstitutes">
              <el-table-column label="替换关键词" width="300px">
                <template slot-scope="scope">
                  <el-table
                    :data="scope.row.keywordSubstitutes"
                    border
                    size="mini"
                    class="c-table-border"
                  >
                    <el-table-column prop="keyword" label="关键词"></el-table-column>
                    <el-table-column prop="substitute" label="替换成"></el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </template>
            <template slot="paramList">
              <el-table-column label="函数参数" width="220px">
                <template slot-scope="scope">
                  <el-table :data="scope.row.paramList" border size="mini" class="c-table-border">
                    <el-table-column prop="order" label="参数序号"></el-table-column>
                    <el-table-column prop="type" label="参数数据类型"></el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </template>
          </c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="定义函数"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        label-width="110px"
      >
        <template slot="keywordSubstitutes">
          <div v-for="(item, i) in formData.keywordSubstitutes" :key="i" style="height:40px;">
            <el-col :span="10">
              <el-form-item
                :prop="`keywordSubstitutes[${i}].keyword`"
                :rules="{ required: true, message: '请输入', trigger: 'blur' }"
              >
                <el-input
                  placeholder="请输入要替换的关键词"
                  v-model="formData.keywordSubstitutes[i].keyword"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="c-center" :span="2">
              <i class="el-icon-right"></i>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :prop="`keywordSubstitutes[${i}].substitute`"
                :rules="{ required: true, message: '请输入', trigger: 'blur' }"
              >
                <el-input
                  placeholder="请输入替换成为的内容"
                  v-model="formData.keywordSubstitutes[i].substitute"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <template v-if="i == formData.keywordSubstitutes.length - 1">
                <i
                  v-if="i != 0"
                  class="el-icon-remove c_red c_pointer c_size_16"
                  @click="formData.keywordSubstitutes.splice(i, 1)"
                ></i>
                <i
                  class="el-icon-circle-plus c_blue c_pointer c_size_16"
                  @click="formData.keywordSubstitutes.push({ keyword: '', substitute: '' })"
                ></i>
              </template>
              <i
                v-else
                class="el-icon-remove c_red c_pointer c_size_16"
                @click="formData.keywordSubstitutes.splice(i, 1)"
              ></i>
            </el-col>
          </div>
        </template>
        <template slot="paramList">
          <div v-for="(item, i) in formData.paramList" :key="i" style="height:40px;">
            <el-col :span="10">
              <el-form-item
                :prop="`paramList[${i}].order`"
                :rules="{ required: true, message: '请输入', trigger: 'blur' }"
              >
                <el-input-number
                  placeholder="请输入参数序号"
                  v-model="formData.paramList[i].order"
                  :controls="false"
                  :precision="0"
                  :min="1"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col class="c-center" :span="2">
              <i class="el-icon-right"></i>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :prop="`paramList[${i}].type`"
                :rules="{ required: true, message: '请选择', trigger: 'change' }"
              >
                <el-select v-model="formData.paramList[i].type" placeholder="请选择参数数据格式">
                  <el-option label="数字" value="Number"></el-option>
                  <el-option label="字符串" value="String"></el-option>
                  <el-option label="数字" value="List"></el-option>
                  <el-option label="对象" value="Map"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <template v-if="formData.paramList.length == 0 || i == formData.paramList.length - 1">
                <i
                  class="el-icon-remove c_red c_pointer c_size_16"
                  @click="formData.paramList.splice(i, 1)"
                ></i>
                <i
                  class="el-icon-circle-plus c_blue c_pointer c_size_16"
                  @click="
                    formData.paramList.push({ order: formData.paramList.length + 1, type: '' })
                  "
                ></i>
              </template>
              <i
                v-else
                class="el-icon-remove c_red c_pointer c_size_16"
                @click="formData.paramList.splice(i, 1)"
              ></i>
            </el-col>
          </div>
          <el-button
            v-if="formData.paramList.length == 0"
            size="mini"
            @click="formData.paramList.push({ order: 1, type: '' })"
          >
            添加函数
          </el-button>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      name: 'definedFunction',
      fpi: {
        page: 1,
        rows: 20
      },
      searchValue: '',
      openDetail: false,
      formData: {
        keywordSubstitutes: [{ keyword: '', substitute: '' }],
        paramList: [{ order: 1, type: '' }]
      },
      extFields: [],
      extField: {},
      options: {}
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('definedFunction', () => {
      this.osg.codeoption(() => {
        this.osg.getFpi();
        this.getData();
      });
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        keywordSubstitutes: [{ keyword: '', substitute: '' }],
        paramList: [{ order: 1, type: '' }],
        exts: {}
      };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:tag|string#or': this.searchValue,
        sortField: 'group,order',
        sortOrder: 'asc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('definedFunction/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs.form &&
          this.$refs.form.$refs.formData &&
          this.$refs.form.$refs.formData.clearValidate();
      });
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax('definedFunction/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('definedFunction/valid.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('definedFunction/invalid.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.ajax('definedFunction/remove.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    }
  }
};
</script>
